// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export const MIN_BROWSER_MAP: BowserModule.IBowserMinVersions = {
    msie: '11',
    msedge: '12',
    firefox: '45',
    chrome: '49',
    safari: '9',
    opera: '30',
    silk: '1',
}
